import { Dispatch, useReducer } from 'react';

import { PaywallScreens } from '~analytics/types';

/**
 * One or two `PaywallScreens` values, the first being the primary
 * paywall feature, the second being an optional more specific paywall
 * trigger.
 *
 * @see PaywallTouchEventAdapter
 */
export type PaywallTouch = [
  paywallScreen: PaywallScreens,
  secondaryFeature?: PaywallScreens
];

export interface PaywallState {
  open: boolean;
  touch: PaywallTouch;
}

export interface PaywallAction {
  type: 'OPEN' | 'CLOSE';
  touch?: PaywallTouch;
}

export type PaywallDispatch = Dispatch<PaywallAction>;

export function usePaywallReducer(): [PaywallState, PaywallDispatch] {
  const reducer = (
    state: PaywallState,
    action: PaywallAction
  ): PaywallState => {
    switch (action.type) {
      case 'OPEN':
        return { open: true, touch: action.touch };

      case 'CLOSE':
        return { open: false, touch: [null] };

      default:
        return state;
    }
  };

  return useReducer(reducer, { open: false, touch: [null] });
}
